var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup370(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_370",
    "data-name": "Group 370",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.148,
    height: 51.147,
    viewBox: "0 0 51.148 51.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M-475.384,138.019a25.577,25.577,0,0,1,25.552,25.675,25.583,25.583,0,0,1-25.65,25.472,25.582,25.582,0,0,1-25.5-25.784A25.585,25.585,0,0,1-475.384,138.019Zm-.04,30.409c.174.164.3.281.427.4,1.871,1.87,3.736,3.747,5.615,5.609a3.3,3.3,0,0,0,3.557.906,3.4,3.4,0,0,0,1.308-5.689c-1.867-1.9-3.763-3.77-5.645-5.654-.133-.133-.258-.273-.43-.457.19-.166.346-.286.483-.423q2.771-2.765,5.537-5.536a3.315,3.315,0,0,0,.929-3.553,3.4,3.4,0,0,0-5.717-1.312c-1.886,1.855-3.744,3.738-5.615,5.608-.135.134-.278.26-.436.407-.167-.159-.308-.29-.444-.425-1.859-1.857-3.711-3.721-5.577-5.572a3.3,3.3,0,0,0-3.557-.9,3.4,3.4,0,0,0-1.3,5.688c1.867,1.9,3.763,3.769,5.646,5.653.133.133.258.274.447.476-.208.171-.386.294-.536.443-1.848,1.842-3.7,3.68-5.536,5.537a3.387,3.387,0,0,0,.4,5.276,3.388,3.388,0,0,0,4.455-.484C-479.426,172.451-477.451,170.46-475.424,168.428Z",
    transform: "translate(500.98 -138.019)",
    fill: "#ff6454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup370);
export default __webpack_public_path__ + "static/media/Group 370.80defa2e7e853cb0ee3fe4ec76ef0700.svg";
export { ForwardRef as ReactComponent };